import React, { forwardRef } from "react";
import { FiEdit2 } from "react-icons/fi";

const SessionItem = forwardRef(({ session, isSelected, onSelect, onEdit, isShared = false }, ref) => (
  <div
    ref={ref}
    className={`flex items-center justify-between p-2 text-sm rounded border border-gray-300 cursor-pointer transition-colors
        ${isSelected ? "bg-primary/10" : "bg-white hover:bg-gray-100"}`}
    onClick={() => onSelect(session.id)}
  >
    <span>{session.title}</span>
    {!isShared && (
      <button
        onClick={(e) => {
          e.stopPropagation();
          onEdit(e, session);
        }}
        className="p-1 hover:bg-gray-200 rounded">
        <FiEdit2 size={16} className="text-gray-500 hover:text-gray-700" />
      </button>
    )}
  </div>
));

export default SessionItem;
